module.exports = __webpack_public_path__ + "img/Hb.38d20fdb.png";